var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    width: 30,
    height: 30,
    transform: "translate(866 993.566)",
    fill: "none",
    stroke: "#b7b5b6",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_54",
    "data-name": "Mask Group 54",
    transform: "translate(-866 -993.566)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_circle_FILL0_wght400_GRAD0_opsz48",
    d: "M91.164,193.958h1.8v-4.968h5v-1.8h-5v-5.208h-1.8v5.208H85.986v1.8h5.178Zm.816,5.986A11.588,11.588,0,0,1,87.326,199a12.093,12.093,0,0,1-6.383-6.385,11.982,11.982,0,0,1,0-9.318,11.979,11.979,0,0,1,2.574-3.8,12.288,12.288,0,0,1,3.811-2.559,11.982,11.982,0,0,1,9.317,0A11.965,11.965,0,0,1,103,183.3a11.976,11.976,0,0,1,0,9.315,12.227,12.227,0,0,1-2.559,3.8,12.086,12.086,0,0,1-3.8,2.574A11.58,11.58,0,0,1,91.98,199.943Zm.007-1.8a10.167,10.167,0,1,0-7.213-2.978A9.774,9.774,0,0,0,91.987,198.148ZM91.972,187.972Z",
    transform: "translate(789.028 820.594)",
    fill: "#0073b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSign);
export default __webpack_public_path__ + "static/media/plus-sign.2834baa814985b8b019f0211dfaedb64.svg";
export { ForwardRef as ReactComponent };